import { render, staticRenderFns } from "./activityProp.vue?vue&type=template&id=2b94973e&scoped=true&"
import script from "./activityProp.vue?vue&type=script&lang=js&"
export * from "./activityProp.vue?vue&type=script&lang=js&"
import style0 from "./activityProp.vue?vue&type=style&index=0&id=2b94973e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b94973e",
  null
  
)

export default component.exports